// @flow
export const INSTALL_HUB_FORM_NAME = 'install-hub';
export const INSTALL_HUB_FORM_FIELD_NAME = 'codes';
export const UPGRADE_NANO1_HUB_FORM_NAME = 'install-nano1-upgrade-claim-hub';
export const UPGRADE_NANO1_HUB_FORM_FIELD_NAME = 'codes';
export const CHANGE_PIN_FORM_NAME = 'change-pin';



// WEBPACK FOOTER //
// ./src/core/state/form/constants.js